import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import axios from 'axios';
import config from '../../../config';

const EditBatchLabelModal = ({ show, handleClose, batchId, currentLabel, refreshBatch }) => {
  const [formData, setFormData] = useState({
    label: '',
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (currentLabel) {
      setFormData({
        label: currentLabel,
      });
    }
  }, [currentLabel]);

  const handleSubmit = async () => {
    if (!formData.label.trim()) {
      alert('Label cannot be empty');
      return;
    }

    setLoading(true);
    try {
      await axios.put(`${config.API_BASE_URL}/production-batches/${batchId}/label`, {
        label: formData.label.trim(),
      });

      refreshBatch();
      handleClose();
    } catch (error) {
      console.error('Failed to update batch label:', error);
      alert('Failed to update batch label');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit Batch Label</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Batch Label</Form.Label>
            <Form.Control
              type="text"
              value={formData.label}
              onChange={(e) => setFormData({ ...formData, label: e.target.value })}
              placeholder="Enter batch label"
              autoFocus
            />
            <Form.Text className="text-muted">
              This label will be displayed as the batch name in the interface.
            </Form.Text>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit} disabled={loading}>
          {loading ? 'Updating...' : 'Update Label'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditBatchLabelModal;
